var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import GridContainer from '@r1-frontend/ui-react/components/layouts/gridContainer';
export var wideBreakpoints = {
    sDesktop: '1567px',
    laptop: '1279px',
    tablet: '999px',
    mobile: '767px',
    sMobile: '359px',
};
export var mobileFirstBreakpoints = {
    sDesktop: '1568px',
    laptop: '1280px',
    tablet: '1000px',
    mobile: '768px',
    sMobile: '360px',
};
var WideContainer = forwardRef(function (_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (<GridContainer ref={ref} modeName={'wide'} {...props}>
            {children}
        </GridContainer>);
});
WideContainer.displayName = 'ForwardedWideContainer';
export default WideContainer;
